
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { Form } from 'vee-validate';
import FormField from '@/components/forms/FormField.vue';
import ActiveSelect from '@/components/forms/components/ActiveSelect.vue';

import toasts from '@/utils/toasts';

import {
  Actions as BundleActions,
  Getters as BundleGetters,
} from '@/store/enums/BundleEnums';

import { BundleSchema } from '@/schemas/bundle.schemas';
import { PlanBundle } from '@/models/PlanBundleModel';

export default defineComponent({
  name: 'bundle-update-form',
  emits: ['dataSubmitted', 'cancelForm'],
  props: {
    prefix: {
      type: String,
      default: '',
    },
  },
  components: {
    Form,
    FormField,
    ActiveSelect,
  },
  data: () => ({
    typeOptions: [
      {
        label: 'One Time',
        value: 'one_time',
      },
      {
        label: 'Recurring',
        value: 'recurring',
      },
    ] as unknown as [],
    loading: false,
    isLoad: false,
    form: {} as typeof Form,
    formData: {} as unknown as PlanBundle,
  }),
  async mounted() {
    this.form = this.$refs.updateBundleForm as typeof Form;
  },
  computed: {
    ...mapGetters({
      bundle: BundleGetters.GET_BUNDLE,
      actionErrors: BundleGetters.GET_ACTION_ERROR,
    }),

    activeValue() {
      return this.bundle.active ? true : false;
    },

    formSchema() {
      return BundleSchema;
    },
  },
  methods: {
    ...mapActions({
      update: BundleActions.UPDATE_BUNDLE,
    }),

    handleCancel() {
      this.$emit('cancelForm');
    },

    resetForm() {
      (this.$refs.updateBundleForm as typeof Form)?.resetForm();

      // Reset the form
      this.form.setValues(this.formData as unknown as PlanBundle);
      this.formData = this.formData as unknown as PlanBundle;
    },
    async submitForm(values) {
      if (this.loading) return;
      this.loading = true;

      this.formData = values;

      const payload = {
        drawId: await this.$route.params.draw_id,
        bundleId: this.bundle.id,
        data: this.formData,
      };

      return await this.update(payload)
        .then(() => {
          this.loading = false;
          this.resetForm();

          this.$emit('dataSubmitted');
        })
        .catch(() => {
          this.loading = false;
          if (this.actionErrors) {
            const { errors, message } = this.actionErrors;

            // Alert when creation request failed
            toasts.error(errors, message, () => {
              return false;
            });
          }
        });
    },
    handleChangeType(value) {
      this.setFieldValue('type', value);
    },
    handleCloseType() {
      this.validateFormField('type');
    },
    handlePlanSelect(value) {
      this.setFieldValue('account_plan_id', value);
    },
    handlePlanClose() {
      this.validateFormField('account_plan_id');
    },
    handleSelectActive(value) {
      this.setFieldValue('active', value);
    },
    handleCloseActive() {
      this.validateFormField('active');
    },
    setFieldValue(field, value) {
      if (!this.form.setFieldValue) return;

      this.form.setFieldValue(field, value);
    },
    validateFormField(field) {
      if (!this.form.validateField) return;

      this.form.validateField(field);
    },
    addPrefix(name, prefix = '') {
      return prefix ? `${prefix}_${name}` : name;
    },
  },

  watch: {
    async bundle(value) {
      const bundleData = await value;
      this.formData = {
        ...bundleData,
        ...{
          active: bundleData.active === 'active' ? 'yes' : 'no',
        },
      };
      this.form.setValues(this.formData);
    },
  },
});
